module.exports = __webpack_public_path__ + "img/vumedi_plugin.05a9116b.svg";